import { createActionType, createFetchAction } from './action-helper';
import endpoints from './login-endpoints';

export const RESET_EXCEED_LOGIN_TIMES = 'RESET_EXCEED_LOGIN_TIMES';
export const LOGOUT = createActionType('LOGOUT');
export const GFB_LOGOUT = createActionType('GFB_LOGOUT');
export const LOGIN = createActionType('LOGIN');
// TODO: deprecate after rollout
export const FETCH_USER_INFO = createActionType('FETCH_USER_INFO');
export const GET_COMPANY_USER_PROFILES = createActionType(
  'GET_COMPANY_USER_PROFILES',
);
export const GET_USERNAME_INFO = createActionType('GET_USERNAME_INFO');
// TODO: deprecate after rollout
export const GET_USER_AUTHORIZATION = createActionType(
  'GET_USER_AUTHORIZATION',
);
export const GET_COMPANY_PERMISSIONS = createActionType(
  'GET_COMPANY_PERMISSIONS',
);
export const RETRIEVE_LKPP_TOKEN = createActionType('GET_LKPP_TOKEN');
export const LINK_COMPANY = createActionType('LINK_COMPANY');
export const PAX_GET_USER_AUTHORIZATION = createActionType(
  'PAX_GET_USER_AUTHORIZATION',
);
export const VERIFY_GFB_SESSION = createActionType('VERIFY_GFB_SESSION');
export const INIT_GFB_USER = createActionType('INIT_GFB_USER');

export const resetExceedLoginTimesAction = () => dispatch => {
  dispatch({
    type: RESET_EXCEED_LOGIN_TIMES,
  });
};

export const loginAction = (user, callback) =>
  createFetchAction(
    LOGIN,
    endpoints.getLoginEpt(),
    { method: 'POST', body: user },
    callback,
  );

export const logoutAction = (token, callback) =>
  createFetchAction(
    LOGOUT,
    endpoints.getLogoutEpt(),
    { method: 'POST', body: token },
    callback,
  );

// TODO: deprecate after rollout
// will be replaced by getCompanyUserProfilesAction
export const fetchUserInfoAction = (token, callback) =>
  createFetchAction(
    FETCH_USER_INFO,
    endpoints.fetchUserInfoEpt(),
    {},
    callback,
    { type: 'Authorization', value: token },
  );

export const getCompanyUserProfilesAction = (token, callback) =>
  createFetchAction(
    GET_COMPANY_USER_PROFILES,
    endpoints.getCompanyUserProfilesEpt(),
    {},
    callback,
    { type: 'Authorization', value: token },
  );

export const linkCompanyAction = (companyID, token, callback) =>
  createFetchAction(
    LINK_COMPANY,
    endpoints.getLinkCompanyEpt(),
    {
      method: 'POST',
      body: { companyID },
    },
    callback,
    { type: 'Authorization', value: token },
  );

export const getUserNameAction = (token, callback) =>
  createFetchAction(
    GET_USERNAME_INFO,
    endpoints.getUserNameEpt(),
    {
      method: 'GET',
    },
    callback,
    { type: 'Authorization', value: token },
  );

// TODO: deprecate after rollout
export const getUserAuthorizationAction = ({ token, companyId }, callback) =>
  createFetchAction(
    GET_USER_AUTHORIZATION,
    endpoints.getAuthorizationEpt({
      scopeType: 'company',
      scopeID: companyId,
    }),
    {
      method: 'GET',
    },
    callback,
    { type: 'Authorization', value: token },
  );

export const getCompanyPermissionsAction = (token, callback) =>
  createFetchAction(
    GET_COMPANY_PERMISSIONS,
    endpoints.getCompanyPermissionsEpt(),
    {
      method: 'GET',
    },
    callback,
    { type: 'Authorization', value: token },
  );

export const retrieveLKPPTokenAction = (token, callback) =>
  createFetchAction(
    RETRIEVE_LKPP_TOKEN,
    endpoints.getExchangeToken(token),
    {
      method: 'GET',
    },
    callback,
    { type: 'Authorization', value: null },
  );

export const getPaxUserInfoAction = userInfo => ({
  type: FETCH_USER_INFO.SUCCESS,
  data: userInfo,
});

export const paxLoginStartAction = () => ({
  type: LOGIN.START,
});

export const paxLoginSuccessAction = () => ({
  type: LOGIN.SUCCESS,
});

export const paxLogoutSuccessAction = () => ({
  type: LOGOUT.SUCCESS,
});

// TODO: implement real get auth call when API is ready for pax users
export const paxGetUserAuthSuccessAction = () => ({
  type: PAX_GET_USER_AUTHORIZATION.SUCCESS,
});

export const initGFBUserAction = () => ({
  type: INIT_GFB_USER.START,
});
